import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { DispositifRepository } from '@domain/dispositif/dispositif.repository';
import { Dispositif, DispositifCreateData } from '@domain/dispositif/dispositif';
import { DispositifSummaryDto, DispositifDetailDto } from '../dtos/dispositif/dispositif.response.dto';
import { DispositifMapper } from '../mappers/dispositif.mapper';

@Injectable()
export class DispositifHttpRepository extends DispositifRepository {
  private readonly baseUrl = `${environment.apiUrl}/dispositif`;

  constructor(private readonly http: HttpClient) { super(); }

  getAll(): Observable<Dispositif[]> {
    return this.http.get<DispositifSummaryDto[]>(this.baseUrl).pipe(
      map(dtos => dtos.map(dto => DispositifMapper.fromSummaryDto(dto)))
    );
  }

  getById(id: number): Observable<Dispositif> {
    return this.http.get<DispositifDetailDto>(`${this.baseUrl}/${id}`).pipe(
      map(dto => DispositifMapper.fromDetailDto(dto))
    );
  }

  create(data: DispositifCreateData): Observable<Dispositif> {
    return this.http.post<DispositifDetailDto>(this.baseUrl, DispositifMapper.toRequestDto(data)).pipe(
      map(dto => DispositifMapper.fromDetailDto(dto))
    );
  }

  update(id: number, data: DispositifCreateData): Observable<Dispositif> {
    return this.http.put<DispositifDetailDto>(`${this.baseUrl}/${id}`, DispositifMapper.toRequestDto(data)).pipe(
      map(dto => DispositifMapper.fromDetailDto(dto))
    );
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
